'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _containers = require('../../containers');
var _components = require('../../components');
var _constants = require('../../constants');
var _LineFilterContainer = require('../../containers/LineFilterContainer/LineFilterContainer.scss');var styles = _interopRequireWildcard(_LineFilterContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LineFiltersProjects = function LineFiltersProjects(props) {var
  types = props.types,rooms = props.rooms,translate = props.translate,propertyTypes = props.propertyTypes;

  return (
    _react2.default.createElement('div', { className: 'filters', style: { height: _constants.filtersHeight + 'px' } },
      _react2.default.createElement('div', { className: styles.filtersCover },
        _react2.default.createElement('div', { className: styles.filtersWrapper },
          _react2.default.createElement('div', { className: styles.locationInput }),
          _react2.default.createElement(_containers.PropertyTypesDropdownContainer, {
            locale: props.locale,
            propertyTypes: propertyTypes,
            propertyTypesValues: types,
            translate: translate,
            handleChange: function handleChange(val) {return props.handleChange('types', val);},
            className: 'lineFilters',
            width: 150 }),

          _react2.default.createElement(_containers.RoomsDropdownContainer, {
            rooms: rooms,
            translate: translate('search_box'),
            handleChange: function handleChange(val) {return props.handleChange('rooms', val);},
            className: 'lineFilters',
            width: 110 }),

          _react2.default.createElement('div', { className: styles.priceWrapper },
            _react2.default.createElement(_components.MinMaxPrices, {
              inFilters: true,
              className: 'lineFiltersPrice',
              translate: translate('search_box', 'searchContainer'),
              minPrice: props.formatPriceParameters('minPrice'),
              maxPrice: props.formatPriceParameters('maxPrice') }),

            _react2.default.createElement('span', null, '\u20AA')),

          _react2.default.createElement(_containers.ProjectStatusDropdown, {
            selectedStatuses: props.status,
            locale: props.locale,
            translate: translate('search_box'),
            handleChange: function handleChange(val) {return props.handleChange('status', val);},
            className: 'lineFilters',
            width: 150 })))));





};

LineFiltersProjects.propTypes = {
  handleChange: _propTypes2.default.func,
  formatPriceParameters: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  types: _propTypes2.default.array,
  propertyTypes: _propTypes2.default.array,
  status: _propTypes2.default.array,
  rooms: _propTypes2.default.array };exports.default =


LineFiltersProjects;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LineFilters/LineFiltersProjects.js
// module id = 2714
// module chunks = 0